import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "row mx-auto my-3"
}
const _hoisted_2 = { class: "col-sm-12 col-md-12" }
const _hoisted_3 = {
  key: 1,
  class: "row mx-auto my-3"
}
const _hoisted_4 = { class: "col-sm-12 col-md-12" }
const _hoisted_5 = { class: "row mx-auto my-3" }
const _hoisted_6 = { class: "col-sm-12 col-md-6" }
const _hoisted_7 = { class: "col-sm-12 col-md-6" }
const _hoisted_8 = {
  key: 0,
  class: "row mx-auto my-3"
}
const _hoisted_9 = { class: "col-sm-12 col-md-12" }
const _hoisted_10 = {
  key: 1,
  class: "row mx-auto my-3"
}
const _hoisted_11 = { class: "col-sm-12 col-md-12" }
const _hoisted_12 = { class: "row mx-auto my-3" }
const _hoisted_13 = { class: "col-sm-12 col-md-6" }
const _hoisted_14 = { class: "col-sm-12 col-md-6" }
const _hoisted_15 = {
  key: 0,
  class: "row mx-auto my-3"
}
const _hoisted_16 = { class: "col-sm-12 col-md-12" }
const _hoisted_17 = {
  key: 1,
  class: "row mx-auto my-3"
}
const _hoisted_18 = { class: "col-sm-12 col-md-12" }
const _hoisted_19 = { class: "row mx-auto my-3" }
const _hoisted_20 = { class: "col-sm-12 col-md-6" }
const _hoisted_21 = { class: "col-sm-12 col-md-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dashboard_filters = _resolveComponent("dashboard-filters")!
  const _component_session_counter = _resolveComponent("session-counter")!
  const _component_pending_visits = _resolveComponent("pending-visits")!
  const _component_visit_report = _resolveComponent("visit-report")!
  const _component_participant_list = _resolveComponent("participant-list")!
  const _component_tab = _resolveComponent("tab")!
  const _component_scheduled_visits = _resolveComponent("scheduled-visits")!
  const _component_completed_visits = _resolveComponent("completed-visits")!
  const _component_tabs = _resolveComponent("tabs")!

  return (_openBlock(), _createBlock(_component_tabs, {
    options: { useUrlFragment: false },
    "nav-class": "nav nav-pills m-3",
    "nav-item-class": "nav-item col-md-4 col-sm-12 text-center",
    "nav-item-link-class": "nav-link btn-dashboard-sub-nav",
    "nav-item-link-active-class": "active"
  }, {
    default: _withCtx(() => [
      _createVNode(_component_tab, {
        prefix: "<h2 class='mt-2'>",
        suffix: " / <i class='far fa-clock text-primary'></i></h4>",
        name: "Pending"
      }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
          ([1,28].includes(_ctx.current_partner))
            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_dashboard_filters, {
                    report_data: _ctx.report_data,
                    onDashboardChange: _ctx.dashboardChange,
                    filter_partner_id: _ctx.filter_partner_id,
                    filter_scenario_id: _ctx.filter_scenario_id
                  }, null, 8, ["report_data", "onDashboardChange", "filter_partner_id", "filter_scenario_id"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.current_partner == 28)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_session_counter, { is_client_admin: true })
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_pending_visits, {
                pending_visits: _ctx.pending_visits,
                pending_visits_total: _ctx.pending_visits_total,
                visit_loading: _ctx.pending_visits_loading,
                is_admin: true,
                reset_pagination: _ctx.reset_pagination,
                onChangePage: _ctx.changePage
              }, null, 8, ["pending_visits", "pending_visits_total", "visit_loading", "reset_pagination", "onChangePage"])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createVNode(_component_visit_report, {
                is_global: true,
                report_data: _ctx.report_data,
                is_client_admin: true
              }, null, 8, ["report_data"]),
              _createVNode(_component_participant_list, {
                report_data: _ctx.pending_participants,
                status: "Pending"
              }, null, 8, ["report_data"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_tab, {
        prefix: "<h2 class='mt-2'>",
        suffix: " / <i class='far fa-calendar-alt text-primary'></i></h4>",
        name: "Scheduled"
      }, {
        default: _withCtx(() => [
          _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
          ([1,28].includes(_ctx.current_partner))
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createElementVNode("div", _hoisted_9, [
                  _createVNode(_component_dashboard_filters, {
                    report_data: _ctx.report_data,
                    onDashboardChange: _ctx.dashboardChange,
                    filter_partner_id: _ctx.filter_partner_id,
                    filter_scenario_id: _ctx.filter_scenario_id
                  }, null, 8, ["report_data", "onDashboardChange", "filter_partner_id", "filter_scenario_id"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.current_partner == 28)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(_component_session_counter, { is_client_admin: true })
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_12, [
            _createElementVNode("div", _hoisted_13, [
              _createVNode(_component_scheduled_visits, {
                scheduled_visits: _ctx.scheduled_visits,
                scheduled_visits_total: _ctx.scheduled_visits_total,
                visit_loading: _ctx.scheduled_visits_loading,
                is_admin: true,
                is_client_admin: true,
                reset_pagination: _ctx.reset_pagination,
                onChangePage: _ctx.changePage
              }, null, 8, ["scheduled_visits", "scheduled_visits_total", "visit_loading", "reset_pagination", "onChangePage"])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createVNode(_component_visit_report, {
                is_global: true,
                report_data: _ctx.report_data,
                is_client_admin: true
              }, null, 8, ["report_data"]),
              _createVNode(_component_participant_list, {
                report_data: _ctx.scheduled_participants,
                status: "Scheduled"
              }, null, 8, ["report_data"])
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_tab, {
        prefix: "<h2 class='mt-2'>",
        suffix: " / <i class='fas fa-check text-primary'></i></h4>",
        name: "Completed"
      }, {
        default: _withCtx(() => [
          _cache[2] || (_cache[2] = _createElementVNode("hr", { class: "w-75 mx-auto" }, null, -1)),
          ([1,28].includes(_ctx.current_partner))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createElementVNode("div", _hoisted_16, [
                  _createVNode(_component_dashboard_filters, {
                    report_data: _ctx.report_data,
                    onDashboardChange: _ctx.dashboardChange,
                    filter_partner_id: _ctx.filter_partner_id,
                    filter_scenario_id: _ctx.filter_scenario_id
                  }, null, 8, ["report_data", "onDashboardChange", "filter_partner_id", "filter_scenario_id"])
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.current_partner == 28)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _createVNode(_component_session_counter, { is_client_admin: true })
                ])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_completed_visits, {
                completed_visits: _ctx.completed_visits,
                completed_visits_total: _ctx.completed_visits_total,
                visit_loading: _ctx.completed_visits_loading,
                is_admin: true,
                is_client_admin: true,
                reset_pagination: _ctx.reset_pagination,
                onChangePage: _ctx.changePage
              }, null, 8, ["completed_visits", "completed_visits_total", "visit_loading", "reset_pagination", "onChangePage"])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createVNode(_component_visit_report, {
                is_global: true,
                report_data: _ctx.report_data,
                is_client_admin: true
              }, null, 8, ["report_data"]),
              _createVNode(_component_participant_list, {
                report_data: _ctx.completed_participants,
                status: "Completed"
              }, null, 8, ["report_data"])
            ])
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}